import { FC, MouseEvent } from 'react'
import { IconButton, MenuItem } from '@mui/material'
import { CustomLabelDropdownWrapper, Menu } from './customLabelDropdown.styles'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { SystemEventName } from 'models'

interface Props {
  open: boolean
  anchorEl: null | HTMLElement
  handleMenuOpen: (event: MouseEvent<HTMLElement>) => void
  handleMenuClose: () => void
  handleEdit: () => void
  handleDelete: () => void
  labelAction: SystemEventName
}

const CustomLabelDropdown: FC<Props> = ({
  open,
  anchorEl,
  handleMenuOpen,
  handleMenuClose,
  handleEdit,
  handleDelete,
  labelAction
}) =>
  labelAction === SystemEventName.CpiCustom ? (
    <CustomLabelDropdownWrapper menuOpen={open}>
      <IconButton className="custom-label-dropdown-menu-button" onClick={handleMenuOpen} size="small">
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
        <MenuItem onClick={handleDelete}>Delete</MenuItem>
      </Menu>
    </CustomLabelDropdownWrapper>
  ) : null

export default CustomLabelDropdown
